import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  PATIENT_API } from '../../ApiNames';


export const fetchData1 = (open: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: open,
});
export const fetchData2 = (close: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: close,
});export const fetchData3 = (appointments: any) => ({
    type: 'FETCH_DATA3_SUCCESS',
    payload: appointments,
});



export const fetchOpenCases = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,uid:uid};
            const apiname = PATIENT_API.patientcases_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchCloseCases = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,uid:uid};
            const apiname = PATIENT_API.patientcases_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAppointmentsData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,uid:uid};
            const apiname = PATIENT_API.patientcases_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchcaronadata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,uid:uid};
            const apiname = PATIENT_API.patientcases_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


